import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

const TRANSLATION_VERSION = "1.0.1"; //+1 on translations update to reset browser cache

// Define backend options
const backendOptions = {
  loadPath: `/locales/{{lng}}/translation.json?v=${TRANSLATION_VERSION}`,
};

const language = localStorage.getItem("lang") || i18n.language || "lt";

const options: any = {
  initImmediate: false,
  debug: false,
  lng: language,
  fallbackLng: "lt",
  keySeparator: false,
  //saveMissing: true,
  supportedLngs: ['en', 'lt'],
  react: {
    useSuspense: true,
    bindI18n: 'loaded languageChanged',
    bindI18nStore: 'added',
  },
  backend: backendOptions,
};

i18n
  .use(Backend)
  //.use(LanguageDetector)
  .use(initReactI18next)
  .init(options);

export default i18n;